import React from 'react';
import { Routes, Route } from 'react-router-dom';


import Top from './Top';
import Login from './Login';
import Logout from './Logout';
import Settings from './Settings';
import Recovery from './Recovery';
import Verification from './Verification';
import { ErrorLookup } from './ErrorStatus';
import { Return } from './ReturnTo';


export default function MainRouter() {
  const login = <Login isRefreshLogin={false} />;
  const logout = <Logout immediate={true} />;

  return (
    <Routes>
      <Route index element={<Top />} />
      <Route path="login" element={login} />
      <Route path="logout" element={logout} />
      <Route path="settings" element={<Settings />} />
      <Route path="recovery" element={<Recovery />} />
      <Route path="verification" element={<Verification />} />
      <Route path="error" element={<ErrorLookup />} />
      <Route path="return" element={<Return />} />
    </Routes>
  );
}
